export default class Vehicle {
  constructor(
    plate = '',
    doors_qtd = 4,
    gearbox = 'Manual',
    model = '',
    type_vehicle_id = '',
    garage_id = null,
    brand = '',
    renavam = '1',
    client_id = null,
    pre_authorization_value = 100,
    card_number = '',
    card_password = null,
    vehicle_model = {
      model: '',
      url: '',
    },
    insurance_tax = 9.99,
    insurance_value = 1000,
    odometer_adjustment = 0,
    isFakeVehicleOrInternal = false,
    fleet_start_date = new Date().toISOString().substr(0, 10),
    price_hour = 12.99,
    price_km = 0.9,
    direction_type = 'Elétrica',
    air_conditioning = true
  ) {
    this.plate = plate;
    this.model = model;
    this.vehicle_model = vehicle_model;
    this.type_vehicle_id = type_vehicle_id;
    this.garage_id = garage_id;
    this.brand = brand;
    this.renavam = renavam;
    this.client_id = client_id;
    this.pre_authorization_value = pre_authorization_value;
    this.card_number = card_number;
    this.card_password = card_password;
    this.gearbox = gearbox;
    this.doors_qtd = doors_qtd;
    this.insurance_tax = insurance_tax;
    this.insurance_value = insurance_value;
    this.allow_reservation_less_than_one_hour = false;
    this.odometer_adjustment = odometer_adjustment;
    this.isFakeVehicleOrInternal = isFakeVehicleOrInternal;
    this.fleet_start_date = fleet_start_date;
    this.price_hour = price_hour;
    this.price_km = price_km;
    this.direction_type = direction_type;
    this.air_conditioning = air_conditioning;
  }
}
